module.exports = __webpack_public_path__ + "img/pålestikk_tredd_ferdig.c354a73d.jpg";